export default "__VITE_ASSET__5TKF_iLw__"